import { useTranslation } from 'react-i18next';

interface FooterProps {
  totalBanks: number;
  totalTransactions: number;
}

export default function Footer({ totalBanks, totalTransactions }: FooterProps) {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative z-10 bg-black border-t-4 border-white py-8 mt-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-4">
          {/* Copyright */}
          <p className="text-white font-mono text-sm tracking-widest">
            © {currentYear} DIRHA. {t('footer.copyright')}
          </p>

          {/* Tagline */}
          <p className="text-gray-400 font-mono text-xs sm:text-sm tracking-wider uppercase">
            {t('footer.tagline')}
          </p>

          {/* Stats */}
          <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-4 text-xs sm:text-sm font-mono text-emerald-400">
            <span className="flex items-center space-x-1">
              <span className="text-emerald-500">✅</span>
              <span>{totalBanks}+ {t('footer.banksSupported')}</span>
            </span>
            <span className="hidden sm:inline">•</span>
            <span className="flex items-center space-x-1">
              <span>{totalTransactions}+ {t('footer.transactionsProcessed')}</span>
            </span>
            <span className="hidden sm:inline">•</span>
            <span className="flex items-center space-x-1">
              <span>{t('footer.aiPowered')}</span>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
